/** Höhe des Titels nach dem Inhalt (Dialog einer Aufgabe, Neue Aufgabe). Solange das Fenster noch nicht sichtbar ist, misst der Browser
 *  0 px; dann bleibt die Höhe aus dem CSS (min-height), statt das Feld auf fast 0 px zu setzen (BAUPLAN-FEINSCHLIFF.md, Abschnitt 5). */
export function titelHoeheSetzen(el: Pick<HTMLTextAreaElement, "style" | "scrollHeight" | "offsetHeight" | "clientHeight">) {
  el.style.height = "auto";
  if (el.scrollHeight > 0) el.style.height = `${el.scrollHeight + el.offsetHeight - el.clientHeight}px`;
  else el.style.height = "";
}
